import {EventEmitter, Injectable} from '@angular/core';
import {DocumentsApiService} from '../../services/api/documents-api.service';
import {NavigationTableRequestModel, NavigationTableResponseModel} from '../../models/file-table.model';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class DocumentsServiceService {
    public request: NavigationTableRequestModel = new NavigationTableRequestModel();

    public $mediator: EventEmitter<NavigationTableResponseModel> = new EventEmitter<NavigationTableResponseModel>();
    public refreshMediator: EventEmitter<any> = new EventEmitter<any>();

    protected items;

    constructor(
        protected api: DocumentsApiService,
        protected route: Router
    ) {
    }

    public prepare(obj: any): NavigationTableRequestModel {
        this.request = Object.assign(this.request, obj);
        return this.request;
    }

    public loadDefaultNav(type = 'all'): void {
        this.loadNav(this.prepare({filter: type}));
    }

    public loadNav(request: NavigationTableRequestModel = null): void {
        if (!request) {
            request = this.request;
        }
        if (!request.guid) {
            delete request.guid;
        }
        if (request.filter !== 'collection') {
            this.api.getFoldersAndFilesTable(request).subscribe((data) => {
                this.$mediator.emit(data);
            });
        } else {
            delete request.guid;
            this.api.getCollectionTable(request).subscribe((data) => {
                data.pagination.filter = 'collection';
                this.$mediator.emit(data);
            });
        }
    }
}
